$(document).ready(function () {
  $('.product-popup-modal__opener').insertBefore('.modal-insert-product-form');
  $('.t9-custom-size-var').insertBefore('.product-form__buttons');

  $('#price-template--17773051478322__main').appendTo('span.product-price-customs');

  $('.product-card-wrapper .full-unstyled-link').click(function (e) {
    e.preventDefault();
    window.location.href = '/products/original-weighted-pillow';
  });

  $('#Banner-template--17281012924722__e15021a7-e86a-465e-8dd7-4d085ed7dae6 a').each(function (index, element) {
    var heading = $(element);
    var word_array, last_word, first_part;

    word_array = heading.html().split(/\s+/); // split on spaces
    last_word = word_array.pop(); // pop the last word
    first_part = word_array.join(' '); // rejoin the first words together

    heading.html([first_part, ' <span class="last-word">', last_word, '</span>'].join(''));
  });

  $('.accordion [id^="Details-"] summary').next().slideUp();
  $('.accordion [id^="Details-"] summary').click(function () {
    $(this).parents('.accordion').toggleClass('active');
    $(this).next().slideToggle();
  });
});
